const FACTOR = {
    mm_to_px: 2.83465,
    inches_to_mm: 25.4,
};
export function convertMMToInches(mm) {
    const inches = formatMM(mm) / FACTOR.inches_to_mm;
    return Math.round(inches * 10) / 10;
}
export function convertInchesToMM(inches) {
    const mm = inches * FACTOR.inches_to_mm;
    return formatMM(mm);
}
export function convertMMToCM(mm) {
    const cm = mm / 10;
    return toFixed(cm, 1);
}
export function convertCMToMM(cm) {
    const mm = cm * 10;
    return toFixed(mm, 0);
}
export function convertMMToPX(mm) {
    return mm * FACTOR.mm_to_px;
}
export function convertPXToMM(px) {
    const mm = px / FACTOR.mm_to_px;
    return formatMM(mm);
}
export function formatMM(mm) {
    mm = Math.round(mm * 10) / 10;
    return toFixed(mm, 0);
}
function toFixed(number, decimals) {
    return Number(number.toFixed(decimals));
}
